import { MagnifyingGlassCircleIcon, XCircleIcon } from "@heroicons/react/20/solid";
import * as React from "react";

interface Props {
    label?: string | JSX.Element;
    onClear?: () => void;
}
export const SearchInput: React.FC<
    Props & React.InputHTMLAttributes<HTMLInputElement>
> = props => {
    const { className, label, onClear, ...rest } = props;
    return (
        <div className={className ?? ""}>
            <label>
                {label ? <div className="mb-1">{label}</div> : null}
                <div className="relative rounded-sm">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <MagnifyingGlassCircleIcon className="text-gray-200 h-6 w-6" />
                    </div>
                    <span className="box flex-1">
                        <input
                            className={`form-input block rounded-sm md:rounded w-full disabled:bg-gray-100 border-gray-300 pl-10 hover:border-brand-600 active:border-brand-400 focus:ring-2 focus:ring-brand-300 ${props.value && onClear ? "pr-10" : ""}`}
                            {...rest}
                        />
                    </span>
                    {props.value && onClear ? (
                        <div
                            className="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer"
                            onClick={onClear}>
                            <XCircleIcon className="text-gray-300 hover:text-gray-700 h-5 w-5" />
                        </div>
                    ) : null}
                </div>
            </label>
        </div>
    );
};
